import React, { useContext } from "react";
import { Grid } from "@mui/material";
import { CustomTextField } from "../../../componentes/atoms/CustomTextField/CustomTextField";
import language from '../../../nls/language.json';
import Context from "../../../context/Context";

export default function PartsInformation({ data }) {
  const {
    selectedCountry,
  } = useContext(Context);

  const keys = Object.keys(language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.informacoesDaPeca.data);
  const remainingKeys = keys.slice(3);

  return (
    <>
      <Grid container className="d-flex justify-content-center">
        {remainingKeys.map(key => (
          <CustomTextField
            className={"m-2"}
            InputProps={{
              readOnly: true,
            }}
            label={language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.informacoesDaPeca.data[key]}
            value={data[key]}
          />
        ))}
      </Grid >
    </>
  );
}